export default __webpack_public_path__ + "static/media/logo.705af8ce.png";